import React, { useEffect, useState } from 'react'
import { Card, Accordion, Button } from 'react-bootstrap';
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';

import _ from 'lodash';
import cx from 'classnames';
import dateformat from "dateformat";

import { createPardotForm, updatePardotForm } from 'actions/forms/pardot';
import { fetchForm, toggleFormManageView } from 'actions/forms/forms';
import { fetchPardotForms, selectPardotForm } from 'actions/integrations/pardot';

import { getBaseUrl } from 'services/util';
import CustomToggle from '../../components/customToggle';
import FormPreview from '../../components/formPreview';
import InfiniteScroll from "components/InfiniteScroll";

import styles from '../../forms.module.scss';

export default function PardotFormConfigurations(props) {
  const dispatch = useDispatch();

  const history = useHistory();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const selectedForm = useSelector(state => _.get(state, "integrations.pardot.forms.selectedForm", null));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));

  const [state, setState] = useState({
    formPreview: false,
    activatedKey: "1",
    testCompleted: false
  })

  const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
  const textareaRef = React.createRef(null);

  let completionCode = `<script> 
  var email = encodeURIComponent('%%email{js}%%')
  var firstName = encodeURIComponent('%%first_name{js}%%')
  var lastName = encodeURIComponent('%%last_name{js}%%')
  var company = encodeURIComponent('%%company{js}%%')
  var jobTitle = encodeURIComponent('%%job_title{js}%%')

  window.location="${apiUrl}/integrations/pardot/form-submit?email=" + email + "&firstName=" + firstName + "&lastName=" + lastName + "&company=" + company + "&title=" + jobTitle 
  </script >`;

  useEffect(() => {
    dispatch(toggleFormManageView(true))
    return () => {
      dispatch(toggleFormManageView(false))
    };
  }, [])

  const handleSaveClick = () => {

    setState(state => {
      return {
        ...state,
        testCompleted: false,
        activatedKey: "2"
      }
    })

    if (selectedForm && !currentForm) {
      var createFormRequest = {
        name: selectedForm.name,
        formId: selectedForm.id,
        type: "pardot"
      }

      dispatch(createPardotForm(createFormRequest))
    }

    if (selectedForm && currentForm && (selectedForm.id != currentForm.configuration.id)) {
      let formId = _.get(selectedForm, "configuration.formId", null);

      if (!formId) {
        formId = selectedForm.id;
      }

      var updateRequest = {
        id: currentForm.id,
        formId: formId
      }

      dispatch(updatePardotForm(updateRequest))
    }
  }

  const handleTestClick = () => {
    setState(state => {
      return {
        ...state,
        formPreview: true
      }
    })
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        activatedKey: "4",
        formPreview: false,
        testCompleted: false
      }
    })
  }

  const handleCustomToggle = (key) => {
    setState(state => {
      return {
        ...state,
        activatedKey: key,
        testCompleted: false
      }
    })
  }

  const handleFormSubmit = () => {
    setState(state => {
      return {
        ...state,
        formPreview: false,
        testCompleted: true,
        activatedKey: "5"
      }
    })
  }

  const handleDoneContainer = () => {
    var url = `${baseUrl}/integration-settings/forms?type=pardot`;
    history.push(url);
  }

  const handleCopyCode = () => {
    handleCustomToggle("3")
    navigator.clipboard.writeText(textareaRef.current.value)
  }

  return (
    <div className={styles.formConfigurationContainer}>
      <Accordion className={styles.accordion} defaultActiveKey={state.activatedKey}>
        <Card>
          <Card.Header className={cx(styles.border_top, { [styles.completed]: state.activatedKey != "1" })}>
            <div className={styles.title} >
              <div className={styles.icon}>
                {state.activatedKey != "1" ? <i className="cleverstory-tick"></i> : "1"}
              </div>
              <div className={styles.name}>Select a Pardot Form</div>
              {selectedForm &&
                <>
                  <div className={styles.divider}></div>
                  <div className={styles.selectedForm}>
                    <div className={styles.title}>Selected form: </div>
                    <div className={styles.formName}>
                      <TruncatedTextWithTooltip content={selectedForm.name} maxWidth="200" placement="top" />
                    </div>
                  </div>
                </>}
            </div>
            <CustomToggle eventKey="1" onClick={() => handleCustomToggle("1")}>Choose a different form</CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <PardotForms />
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.border_top, styles.pt_30)}>
                <CustomToggle eventKey="1" onClick={() => handleSaveClick()} isComplete={true} disabled={!selectedForm}>Save & Continue</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 2 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 2 ? <i className="cleverstory-tick"></i> : "2"}
              </div>
              <div className={styles.name}>Copy the code</div>
            </div>
            <CustomToggle eventKey="2" onClick={() => handleCustomToggle("2")}>Copy Code</CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <div className={styles.bodyContainer}>
                <div className={styles.copyContainer}>
                  <div className={styles.content}>
                    <textarea ref={textareaRef} readOnly={true} value={completionCode}></textarea>
                  </div>
                </div>
              </div>
              <div className={cx(styles.bottom, styles.doneButtonContainer)}>
                <CustomToggle eventKey="2" onClick={() => handleCopyCode()} isComplete={true}>Copy Code</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 3 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 3 ? <i className="cleverstory-tick"></i> : "3"}
              </div>
              <div className={styles.name}>Paste the code</div>
            </div>
            <CustomToggle eventKey="3" onClick={() => handleCustomToggle("3")}>View the instruction</CustomToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              <PasteCode />
              <div className={cx(styles.bottom, styles.doneButtonContainer)}>
                <CustomToggle eventKey="3" onClick={() => handleCustomToggle("4")} isComplete={true}>Done</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 4 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 4 ? <i className="cleverstory-tick"></i> : "4"}
              </div>
              <div className={styles.name}>Test the code</div>
            </div>
            {state.testCompleted && <div className={styles.success}>Test Successfull</div>}
            {!state.testCompleted && <CustomToggle eventKey="4" onClick={() => handleCustomToggle("4")}>Test the form</CustomToggle>}
          </Card.Header>
          <Accordion.Collapse eventKey="4">
            <Card.Body>
              <TestTheCode />
              <div className={cx(styles.bottom, styles.doneButtonContainer)}>
                <CustomToggle eventKey="4" onClick={() => handleTestClick()} isComplete={true}>Test the Code</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      {state.formPreview &&
        <FormPreview preview={state.formPreview} editable={true} form={currentForm} onClose={handleClose} onFormSubmit={() => handleFormSubmit()} />
      }

      {parseInt(state.activatedKey) > 1 &&
        <div className={styles.finishButton}>
          <Button className={styles.actionButton}
            onClick={handleDoneContainer}
            size="sm"
            variant="primary"
          >
            Done
          </Button>
        </div>
      }
    </div>
  );
}

function PardotForms(props) {
  const dispatch = useDispatch();
  const page = useSelector(state => _.get(state, "integrations.pardot.forms.page", 0));
  const loading = useSelector(state => _.get(state, "integrations.pardot.forms.loading", false));
  const loadMoreResults = useSelector(state => _.get(state, "integrations.pardot.forms.loadMore", 0));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));
  const [order, setOrder] = useState(false)
  const forms = useSelector(state => _.get(state, "integrations.pardot.forms.items", []));
  const headers = ["Name", "Created on", "Updated on"]
  const [selectedFormId, setSelectedFormId] = useState(null);
  const [embedCode, setEmbedCode] = useState("");
  const selectedForm = useSelector(state => _.get(state, "integrations.pardot.forms.selectedForm", null));

  const { formId } = useParams();

  const loadMore = () => {
    handleSorting(page)
  }

  const handleSorting = (page) => {
    const request = {
      page: page,
      limit: 20,
      sort: 'name',
      order: order ? 'asc' : 'desc'
    }

    dispatch(fetchPardotForms(request));
  }

  useEffect(() => {
    if (formId && formId != "new") {
      dispatch(fetchForm(formId))
      return;
    }
  }, [formId])

  useEffect(() => {
    if (currentForm) {
      var formId = _.get(currentForm, 'configuration.formId', null);
      var embedCode = _.get(currentForm, 'configuration.embedCode', null);

      setEmbedCode(embedCode);
      setSelectedFormId(formId)
      dispatch(selectPardotForm(currentForm))
    }
  }, [currentForm])

  useEffect(() => {
    handleSorting(0)
  }, [order])

  const handleSelectForm = (form) => {
    setSelectedFormId(form.id);
    setEmbedCode(form.embedCode);
    dispatch(selectPardotForm(form))
  }

  const getFormattedDate = (dateString) => {
    let date = dateString.split("T")[0];
    return dateformat(date, "dd mmm yyyy")
  }

  return (
    <div className={styles.externalFormContainer}>
      <div className={styles.left}>
        <div className={styles.formData}>
          <div className={cx(styles.row, styles.no_border)}>
            <div className={cx(styles.container, styles.no_border)}>
              <div className={styles.column}>Name</div>
              <div className={styles.column} onClick={() => { setOrder(!order) }}>
                Created on
                <div className={cx(styles.sortIcon, { [styles.asc]: order })} >
                  <i className={cx(`cleverstory-drop-down`)} />
                </div>
              </div>
              <div className={styles.column}>Updated on</div>
            </div>
          </div>
          {loading && forms.length == 0 && <div className={styles.loadingMessage}>Loading Forms ...</div>}

          {forms.length > 0 && <InfiniteScroll
            className={cx(styles.scrollable)}
            loading={loading}
            hasMore={loadMoreResults}
            loadMore={() => { loadMore() }}>

            {forms.map(form => {
              var isActive = form && form.id === selectedFormId;
              const createdDate = _.get(form, 'createdAt');
              const updatedDate = _.get(form, 'updatedAt');

              return (
                <FormData getFormattedDate={getFormattedDate} form={form} isActive={isActive} handleSelectForm={handleSelectForm}
                  selectedFormId={selectedFormId} createdDate={createdDate} updatedDate={updatedDate} />
              )
            })}
          </InfiniteScroll>}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.contactForm} id="contact_form">
          {selectedFormId && <div className={styles.pardotFormPreview} onClick={(e) => e.preventDefault()} dangerouslySetInnerHTML={{ __html: embedCode }} />}
          {!selectedFormId && <div>Select any form to display !</div>}
        </div>
      </div>
    </div>
  )
}

function FormData({ getFormattedDate, form, isActive, handleSelectForm, selectedFormId, createdDate, updatedDate }) {

  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }
  return (
    <div className={cx(styles.row, { [styles.active]: isActive })}>
      <div className={styles.container}>
        <div className={cx(styles.radioButton, styles.column)} onClick={() => handleSelectForm(form)}>
          <input type="radio" checked={selectedFormId === form.id}></input>
          <label className={cx(styles.formName)}>
            <Tooltip placement="top" content={form.name} disabled={!tooltip}>
              <Truncate width={200} ellipsis={(<span>...</span>)} onTruncate={handleTooltip} lines={1}>
                {form.name}
              </Truncate>
            </Tooltip>
          </label>
        </div>
        <div className={cx(styles.data, styles.column)}>{getFormattedDate(createdDate)}</div>
        <div className={cx(styles.data, styles.column)}>{getFormattedDate(updatedDate)}</div>
      </div>
    </div>
  )
}

function TestTheCode() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.testTheCode}>
        <div className={styles.tcContent}>
          Just to make sure everything's working the way it has to, please test the form by entering sample data. If the test is successful, the sample entry should be recorded in your database. Incase the test is unsuccessful, please recheck the connection with the third party application where you’re importing the form from.         </div>
      </div>
    </div>
  )
}

function PasteCode() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.pasteCode}>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>1.</span> &nbsp; Log into your Pardot account.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_1.png" alt="Pardot Form Step 1" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>2.</span> &nbsp; Navigate to the 'Content' Tab.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_2.png" alt="Pardot Form Step 2" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>3.</span> &nbsp; Scroll down to see and choose the form you selected here in Cleverstory.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_3.png" alt="Pardot Form Step 3" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>4.</span> &nbsp; Click the desired form.</div>
          <div className={styles.title}><span className={styles.sNo}>5.</span> &nbsp; Here, click 'Edit Form'.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_4_and_5.png" alt="Pardot Form Step 4 and 5" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>6.</span> &nbsp; Now, navigate to step 4, 'Completion Actions'.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_6.png" alt="Pardot Form Step 6" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>7.</span> &nbsp; Under the 'Thank You Content' tab, enter the submission message you want.</div>
          <div className={styles.title}><span className={styles.sNo}>8.</span> &nbsp; Navigate to the 'Thank You Code' tab, and paste the code that was copied from Cleverstory.</div>

          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_7.png" alt="Pardot Form Step 7" />
          </div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_8.png" alt="Pardot Form Step 8" />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}><span className={styles.sNo}>9.</span> &nbsp; Hit 'Save & Close'.</div>
          <div className={styles.image}>
            <img src="https://d2uav5q06z9nv6.cloudfront.net/public/cleverstory/images/forms/pardot/pardot_form_step_9.png" alt="Pardot Form Step 9" />
          </div>
        </div>
      </div>
    </div>
  )
}